import { MagicContainerRoutes } from '@bn/app-mc/src/lib/enums';
import { AppRoutes, CommonRoutes } from '@bn/dashboard-core/enums';
import { DnsPath } from '@bn/shared/entities/enums';
import { MenuItem } from './models';

export const addMenuConfig: MenuItem[] = [
  {
    type: 'link',
    label: 'Pull Zone',
    route: `/${AppRoutes.CDN}/${CommonRoutes.Add}`,
    icon: 'pull-zone-icon.svg',
    group: 'delivery',
  },
  {
    type: 'link',
    label: 'Storage Zone',
    route: `/${AppRoutes.Storage}/${CommonRoutes.Add}`,
    icon: 'storage-zone-icon.svg',
    group: 'delivery',
  },
  {
    type: 'link',
    label: 'Stream Library',
    route: `/${AppRoutes.Stream}/${CommonRoutes.Add}`,
    icon: 'stream-library-icon.svg',
    group: 'delivery',
  },
  {
    type: 'link',
    label: 'DNS zone',
    route: `/${AppRoutes.DNS}/${DnsPath.Zones}/${CommonRoutes.Add}`,
    icon: 'dns-zone-icon.svg',
    group: 'delivery',
  },
  {
    id: 'mc-app-add',
    type: 'link',
    label: 'App',
    route: `/${AppRoutes.MagicContainers}/${MagicContainerRoutes.Apps}/${CommonRoutes.Add}`,
    icon: 'app-icon.svg',
    // featureFlag: FeatureFlags.mc,
    group: 'compute',
  },
  {
    type: 'link',
    label: 'Script',
    route: `/${AppRoutes.Script}/${CommonRoutes.Add}`,
    icon: 'script-icon.svg',
    group: 'compute',
  },
  {
    type: 'link',
    label: 'DNS Script',
    route: `/${AppRoutes.DNS}/${DnsPath.Scripts}/${CommonRoutes.Add}`,
    icon: 'script-icon.svg',
    group: 'compute',
  },
  {
    type: 'link',
    label: 'Database',
    route: `/${AppRoutes.Database}/${CommonRoutes.Add}`,
    icon: 'database-icon.svg',
    group: 'compute',
  },
];
